import { Scrollbar as S } from ".";

customElements.define("scrollbar-provider", S.Provider);
customElements.define("scrollbar-container", S.Container);
customElements.define("scrollbar-content", S.Content);
customElements.define("scrollbar-track-x", S.TrackX);
customElements.define("scrollbar-track-y", S.TrackY);
customElements.define("scrollbar-thumb-x", S.ThumbX);
customElements.define("scrollbar-thumb-y", S.ThumbY);
